import React, { useState, useEffect } from "react"
import { navigate } from "gatsby"
import { useStore } from "../teafuljs/store"
import { getTranslation } from "../scripts/getTranslation"
import { makeStyles } from "@material-ui/core/styles"
import SphereViewData from '../data/newKeyPassages.json'
import SphereCategoryTitle from "./SphereCategoryTitle"
import CheckMark from "./CheckMark"
import GetSegment from "../scripts/NavigateToSegment"
import getVersionVerse from "../scripts/getVersionVerse"

const useStyles = makeStyles(theme => ({
  categoryTitle: {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },
  title: {
    margin: "0 20px",
    display: "flex",
    justifyContent: "flex-start",
  },
  checkmark: {
    height: "30px",
    width: "30px",
    minHeight: "30px",
    minWidth: "30px",
    // flex: 0,
    display: "block"
  }
}))

const filterPassages = sphereId => {
  const newObject = {};
  const ids = Object.keys(SphereViewData).filter(id => id.substring(0, 3) === sphereId)
  ids.forEach(id => {
    const data = SphereViewData[id];
    const { cat } = data;
    if (!newObject[cat]) {
      newObject[cat] = {};
      newObject[cat][id] = data
    } else {
      newObject[cat][id] = data
    }
  })
  return newObject
}

export default function SphereView52Passages({sphereId, location}) {
  const translations = useStore.translations()[0]
  const language = useStore.language()[0]
  const version = useStore.version()[0]
  const versification = useStore.versification()[0]
  const AvailableContent = useStore.AvailableContent()[0]
  const [showSpheres, setShowSpheres] = useStore.showSpheres()
  const [currentSphere, setCurrentSphere] = useStore.currentSphere()
  const [currentKeyPassage, setKeyPassage] = useStore.currentKeyPassage()
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID()
  const [history, setHistory] = useStore.history()
  const [searchID, setSearchID] = useStore.searchID()
  const classes = useStyles()
  const sphereObject = filterPassages(sphereId);
  const categories = Object.keys(sphereObject);

  // function search(RefID) {
  //   setHistory([
  //     {
  //       page: window.location.pathname,
  //       language: language,
  //       version: version,
  //       segment: currentSegmentID,
  //       scrollY: window.scrollY,
  //     },
  //     ...history,
  //   ])
  //   const refInfo = RefID.split("-")
  //   const segment = GetSegment(
  //     refInfo[0],
  //     parseInt(refInfo[1]),
  //     parseInt(refInfo[2])
  //   )
  //   setCurrentSegmentID(segment)
  //   navigate("/reader")

  // }

  function search(RefID) {
    setShowSpheres(true)
    setHistory([
      {
        page: window.location.pathname,
        language: language,
        version: version,
        segment: currentSegmentID,
        scrollY: window.scrollY,
      },
      ...history,
    ])
    const refInfo = RefID.split("-")
    const segment = GetSegment(
      refInfo[0],
      parseInt(refInfo[1]),
      parseInt(refInfo[2])
    )
    setSearchID(RefID)
    if (location.pathname !== "/reader") {
      setCurrentSegmentID(segment)
      navigate("/reader")
    } else {
      // props.closeMenu()
      setCurrentSegmentID(segment)
    }
  }

  function goToKP(id) {
    const kPNum = id.split("-")[1]
    const newKP = `${sphereId}-${kPNum}`
    const versionRef = getVersionVerse(
      versification[version],
      SphereViewData[newKP].ref
    )
    const book = versionRef.substring(0, 3)
    const isAvailable =
      AvailableContent &&
      AvailableContent.content &&
      AvailableContent.content[language] &&
      AvailableContent.content[language][version] &&
      AvailableContent.content[language][version][book] &&
      AvailableContent.content[language][version][book].segments &&
      AvailableContent.content[language][version][book].segments.length > 1
        ? true
        : false
    if (isAvailable) {
      search(versionRef)
    }
  }

  return (
    <div className={classes.root}>
      {categories.map(cat => {
        const ids = Object.keys(sphereObject[cat]);
        return (
          <div>
            <SphereCategoryTitle key={cat} cat={cat} hasVideo />
            <div>
              {ids.map(id => {
                const { title, ref, number } = sphereObject[cat][id]
                const book = ref.substring(0, 3)
                const isAvailable =
                  AvailableContent.content[language][version][book] &&
                  AvailableContent.content[language][version][book].segments
                    .length > 1
                    ? true
                    : false
                return (
                  <div
                    className={classes.title}
                    onClick={() => goToKP(id)}
                    style={!isAvailable ? { color: "grey" } : {}}
                  >
                    <span className={classes.checkmark}>
                      <CheckMark
                        language={language}
                        version={version}
                        id={id}
                        empty
                        disable
                      />
                    </span>
                    {"\u00A0"}
                    <span>
                      {number}.{" "}
                      {getTranslation(
                        translations,
                        language,
                        "KeyPassages",
                        title
                      )}
                    </span>
                  </div>
                )
              })}
            </div>
          </div>
        )
      }
      )}
    </div>
  )
}
